import { render, staticRenderFns } from "./HomeTabsContent.vue?vue&type=template&id=b9180e4a&"
import script from "./HomeTabsContent.vue?vue&type=script&lang=js&"
export * from "./HomeTabsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports